export default __webpack_public_path__ + "35ae5b8441acc025953647a54355c2d4.svg";